import web from '../../assets/images/services/web.svg'
import mobile from '../../assets/images/services/mobile.svg'
import ui from '../../assets/images/services/ui.svg'

function ServicesSection() {
	return (
		<section className='mt-[50px] sm:mt-[70px]' id='services'>
			<div className='flex flex-col items-center'>
				<p className='text-center text-black dark:text-white font-medium text-[20px] sm:text-[26px] xl:text-[32px]'>
					Мои услуги
				</p>
				<p className='mt-[15px] text-dark-100 sm:mt-[25px] text-center w-[300px] sm:w-[360px]'>
					Являясь веб-разработчиком я не остановился только на
					создании сайтов. Я захотел попробовать себя в похожих сферах
					и у меня это получилось. В данном блоке вы можете посмотреть
					обобщенно про мои умения.
				</p>
			</div>
			<div className='mt-[25px] sm:mt-[45px] grid grid-cols-1 md:grid-cols-3 gap-[17px] '>
				<div className='flex flex-col items-center justify-center w-full h-[290px] md:h-[250px] xl:w-full xl:h-[225px] bg-white dark:bg-dark-300'>
					<img src={web} alt='web' className='h-[80px]' />
					<p className='text-black text-center dark:text-white mt-[40px] text-[20px] font-medium md:text-[18px] lg:text-[20px]'>
						Web разработка
					</p>
					<p className='text-dark-100 text-center mt-[16px] text-[18px] md:text-[16px] lg:text-[18px]'>
						Блог, Интернет-магазин
					</p>
				</div>
				<div className='flex flex-col items-center justify-center w-full h-[290px] md:h-[250px] xl:w-full xl:h-[225px] bg-white dark:bg-dark-300'>
					<img src={mobile} alt='web' className='h-[80px]' />
					<p className='text-black text-center dark:text-white mt-[40px] text-[20px] font-medium md:text-[18px] lg:text-[20px]'>
						Мобильная разработка
					</p>
					<p className='text-dark-100 text-center mt-[16px] text-[18px] md:text-[16px] lg:text-[18px]'>
						Фитнес трекер, Калькулятор
					</p>
				</div>
				<div className='flex flex-col items-center justify-center w-full h-[290px] md:h-[250px] xl:w-full xl:h-[225px] bg-white dark:bg-dark-300'>
					<img src={ui} alt='web' className='h-[80px]' />
					<p className='text-black text-center dark:text-white mt-[40px] text-[20px] font-medium md:text-[18px] lg:text-[20px]'>
						UI/UX Дизайн
					</p>
					<p className='text-dark-100 text-center mt-[16px] text-[18px] md:text-[16px] lg:text-[18px]'>
						Моб. приложения, Вебсайты
					</p>
				</div>
			</div>
		</section>
	)
}

export default ServicesSection
